import { supabase } from '@/lib/supabaseClient';
import { withRetry } from '@/utils/retry';

export interface DigestPreference {
  id: string;
  userId: string;
  orgId: string;
  frequency: 'daily' | 'weekly' | 'none';
  enabled: boolean;
}

interface DigestRow {
  id: string;
  user_id: string;
  org_id: string;
  frequency: string;
  enabled: boolean;
}

function convert(row: DigestRow): DigestPreference {
  return {
    id: row.id,
    userId: row.user_id,
    orgId: row.org_id,
    frequency: row.frequency as DigestPreference['frequency'],
    enabled: row.enabled,
  };
}

export async function getDigestPreference(orgId: string): Promise<DigestPreference | null> {
  const { data, error } = await withRetry(() =>
    supabase
      .from('digest_preferences')
      .select('*')
      .eq('org_id', orgId)
      .maybeSingle()
  );
  if (error) throw error;
  return data ? convert(data) : null;
}

export async function upsertDigestPreference(opts: {
  userId: string;
  orgId: string;
  frequency: string;
  enabled: boolean;
}): Promise<DigestPreference> {
  const { data, error } = await withRetry(() =>
    supabase
      .from('digest_preferences')
      .upsert(
        {
          user_id: opts.userId,
          org_id: opts.orgId,
          frequency: opts.frequency,
          enabled: opts.enabled,
        },
        { onConflict: 'user_id,org_id' }
      )
      .select()
      .single()
  );
  if (error || !data) throw error || new Error('Failed to upsert digest preference');
  return convert(data);
}
